import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogResult } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { User } from '../../user/user';
import { BenutzerBenutzerrecht, Benutzerrecht } from '../BenutzerBenutzerrecht';

@Component({
    selector: 'kiene-benutzer-benutzerrecht-dialog',
    templateUrl: './benutzer-benutzerrecht-dialog.component.html',
    styleUrls: ['./benutzer-benutzerrecht-dialog.component.scss'],
})
export class BenutzerBenutzerrechtDialogComponent implements OnInit {
    public benutzer: User;
    public benutzerrecht: Benutzerrecht;

    constructor(
        @Inject(MAT_DIALOG_DATA) public bbr: BenutzerBenutzerrecht,
        public dialogRef: MatDialogRef<BenutzerBenutzerrechtDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        if (this.bbr) {
            this.benutzer = new User();
            this.benutzer.benutzer_id = this.bbr.benutzer_id;
            this.benutzer.vorname = this.bbr.vorname;
            this.benutzer.nachname = this.bbr.nachname;

            this.benutzerrecht = new Benutzerrecht();
            this.benutzerrecht.benutzerrecht_id = this.bbr.benutzerrecht_id;
            this.benutzerrecht.bezeichnung = this.bbr.benutzerrecht;
        }
    }

    public selectedBenutzer(benutzer: User): void {
        this.benutzer = benutzer;
    }

    public selectedBenutzerrecht(benutzerrecht: Benutzerrecht): void {
        this.benutzerrecht = benutzerrecht;
    }

    public cancel(): void {
        const result = new ConfirmDialogResult();
        result.ok = true;
        this.dialogRef.close(result);
    }

    public save(): void {
        let url: string = this.apiBaseUrl + 'benutzer_benutzerrechte/create.php';

        const bbr = new BenutzerBenutzerrecht();
        bbr.bbr_id = this.bbr?.bbr_id;
        bbr.benutzerrecht_id = this.benutzerrecht.benutzerrecht_id;
        bbr.benutzer_id = this.benutzer.benutzer_id;

        this.api.post(url, bbr).subscribe({
            next: () => {
                const result = new ConfirmDialogResult();
                result.ok = true;
                result.confirmed = true;
                this.dialogRef.close(result);
            },
            error: err => {
                this.messageService.errorMessage('Speichern fehlgeschlagen!', err);
            },
        });
    }
}
